<template>
  <div class="tg-login">
    <div class="tg-login--container changePwd">
      <h1 class="tg-login--title">{{ title }}</h1>
      <div :class="formClass">
        <el-row type="flex" align="middle ma-t-4">
          <div class="col-3 text-align-center column">
            {{ $t("column.input_username") }}
          </div>
          <div class="col-9">
            <el-input
              v-model="formData.username"
              class="tg-input"
              :placeholder="$t('column.input_username')"
            ></el-input>
            <input type="text" style="display:none;" autocomplete="off">
          </div>
        </el-row>
        <el-row type="flex" align="middle ma-t-4">
          <div class="col-3 text-align-center column">{{ $t("column.password") }}</div>
          <div class="col-9">
            <div class="tg-input el-input">
              <input type="text" style="display:none;" autocomplete="off">
              <input 
                v-model="formData.password" 
                type="password" autocomplete="new-password" 
                :placeholder="$t('component.form.input.placeholder.password[2]')" 
                class="el-input__inner" >
            </div>
            <!-- <el-input
              v-model="formData.password"
              class="tg-input"
              type="password"
              :placeholder="$t('component.form.input.placeholder.password[2]')"
            ></el-input> -->
          </div>
        </el-row>
        <el-row type="flex" align="middle ma-t-4">
          <div class="col-3 text-align-center column">
            {{ $t("column.repassword") }}
          </div>
          <div class="col-9">
            <el-input
              v-model="repassword"
              class="tg-input"
              :placeholder="$t('component.form.input.placeholder.password[2]')"
              type="password"
            ></el-input>
          </div>
        </el-row>
        <el-row type="flex" justify="end" align="middle" class="ma-t-5">
          <tg-button
            round
            class="tg-btn-prompt--next col-9"
            :class="{ active }"
            @click.native="handleSubmit"
            >{{ $t("component.btn.changePwd") }}</tg-button
          >
        </el-row>
      </div>
      <!-- 錯誤彈窗 -->
      <el-alert
        ref="alert"
        tabindex="-1"
        style="outline: none;"
        type="tg-alert"
        show-icon
        v-show="alert.show"
        :style="alert.style"
        @blur.native="handleAlertClose"
        @close="handleAlertClose"
        >{{ alert.message }}</el-alert
      >
      <tg-dialog
        showIcon
        showFooter
        :visible.sync="showDialog"
        :subject="alert.subject"
        :subtitle="alert.subtitle"
        top="35vh"
        width="20%"
        :theme="alert.type"
        :confirmLabel="alert.type == 'info' ? $t('component.btn.finish') : null"
        @on-confirm="handleFinish"
      ></tg-dialog>
    </div>
  </div>
</template>

<script>
import TgButton from "@/components/button/TgButton";
import TgDialog from "@/components/dialog/TgDialog";

import apis from "@/apis";
import validator from "@/mixins/validator";
export default {
  components: {
    TgButton,
    TgDialog,
  },
  mixins: [validator],
  data() {
    return {
      repassword: "",
      formData: {},
      showDialog: false,
      alert: {
        type: "warning",
        subject: "",
        subtitle: "",
      },
    };
  },
  computed: {
    active() {
      return (
        !!this.formData.username &&
        !!this.formData.password &&
        !!this.repassword
      );
    },
    formClass() {
      return ["tg-login--form", this.$route.name, "col-10"];
    },
    title() {
      return this.$t("page.other.changePwd.title");
    },
    subject() {
      return this.$t("message.success.changePwd.title");
    },
    subtitle() {
      return this.$t("message.success.changePwd.subtitle");
    },
  },
  created() {
    this.validateErrorHandler = this.showAlert;
  },
  methods: {
    showAlert(subject, subtitle = "", type = "warning") {
      this.alert = {
        type,
        subject,
        subtitle,
      };
      this.$nextTick(() => {
        this.showDialog = true;
      });
    },
    handleAlertClose() {
      this.alert.show = false;
    },
    handleSubmit() {
      if (!this.validatePassword(this.formData.password)) {
        return;
      }

      if (
        !this.validatePasswordChange(this.formData.password, this.repassword)
      ) {
        return;
      }
      apis.changePwd(this.formData).then((response) => {
        if (response.retcode == 0) {
          this.showAlert(
            this.$t("message.success.changePwd.title"),
            this.$t("message.success.changePwd.subtitle"),
            "info"
          );
        } else {
          this.showAlert(this.$t("statusCode["+response.retcode+"]"));
        }
      });
    },
    handleFinish() {
      if (this.alert.type == "info") {
        this.$router.push({ name: "login" });
      }
    },
  },
};
</script>
